import {
    getCurrentStateOfLvDocument,
    populateAnnotationComponent,
    removingAnnotation
} from '../../Utils/helpers';
import {removeLVDocumentDB, setLVDocumentDB} from '../../Database/lvDocumentDAO';
//import {setAnnotationDB} from '../../Database/AnnotationsDAO';
import React, {useState} from 'react';
import uuid from 'react-uuid';
import $ from 'jquery';

function HighlightComponent(props) {
    const [highlightPossibilty] = useState(props.highlightPossible);
    const [ozDataUnitValue] = useState(props.ozDataUnit);
    const [stateValue] = useState(props.state);
    const [TAG_COLORS] = useState({
        Default: 'rgb(82, 125, 219)',
        Potenzial: 'rgb(5, 165, 107)',
        Hinweis: 'rgb(231, 185, 20)',
        Risiko: 'rgb(239, 3, 3)'
    });

    /***
     * Checks if the provided data is empty or not.
     * @param data
     * @returns {boolean}
     */
    function isNothing(data) {
        return data === '';
    }

    //region Set ID and populate the annotation in the Annotation component
    const setAnnotation = (annotationID) => {
        // Maintain the Annotation ID for 'Last Advice' Feature in Advices Modal UI.
        if (localStorage.getItem('annotationID') !== '') {
            localStorage.setItem('lastAnnotationID', localStorage.getItem('annotationID'));
        }
        localStorage.setItem('annotationID', annotationID);
        populateAnnotationComponent(annotationID).then((r) => r);
        //make the annotation as current
        //$('mark').removeAttr('class');
        document.getElementById(annotationID).classList.add('dashed-border-mark');
    };

    function getSelectionWithEndOffsets(element, state, oz, annotationAttributs) {
        /**
         * Takes the element where it needs to perform highlight and text selection and highlight using the color code
         * and computes the relative offsets to the container that includes the child elements. Prevent accidental highlight
         * to most extent. And we can change the type of highlight by rehighlighting the same text. Stores all the data behind
         * the annotation in a LocalStorge
         *
         * @type {VoidFunction}
         */

        let [rowId, mengeValue, shortText, dgl_ref, report_ref] = annotationAttributs;
        let endOffsets = 0;
        let doc = element.ownerDocument || element.document;
        let win = doc.defaultView || doc.parentWindow;
        let sel = doc.selection;
        let annotationID = uuid();
        if (typeof win.getSelection != 'undefined') {
            sel = win.getSelection();
            if (sel.rangeCount > 0) {
                let range = win.getSelection().getRangeAt(0);
                let preCaretRange = range.cloneRange();
                preCaretRange.selectNodeContents(element);
                preCaretRange.setEnd(range.endContainer, range.endOffset);
                endOffsets = preCaretRange.toString().length;
                if (window.getSelection().toString().length >= 3) {
                    let newNode = document.createElement('mark');
                    newNode.setAttribute('id', annotationID);
                    let elemID = newNode.id;
                    newNode.onmouseenter = () => setAnnotation(elemID);
                    newNode.setAttribute('style', 'background-color:' + TAG_COLORS[state] + ';');
                    range.surroundContents(newNode);
                }
            }
        } //Computing the end offset of the selection
        else if (sel && sel.type !== 'Control') {
            let textRange = sel.createRange();
            let preTextRange = doc.body.createTextRange();
            preTextRange.moveToElementText(element);
            preTextRange.setEndPoint('EndToEnd', textRange);
            endOffsets = preTextRange.text.length;
        }
        // Computing later the start offsets with character length of the selection
        let selectionText = window.getSelection().toString();
        window.getSelection().removeAllRanges();
        let lengthOfSelection = selectionText.length;
        let startOffsets = endOffsets - lengthOfSelection;

        if (/^ *$/.test(selectionText) === false && selectionText.length >= 3) {
            // add the long text innerHTML with mark elements in order to reload highlights.
            if (typeof shortText === "object") {
                shortText = shortText[0]
            }
            let annotation = {
                unique_id: annotationID,
                ord: oz,
                rowId: rowId,
                Annotation: selectionText.trim(),
                menge: mengeValue,
                mengeUnitValue: '',
                value: '0',
                adviceID: '1',
                position: [startOffsets, endOffsets],
                timestamp: Date.now(),
                short_text: shortText,
                law: '',
                kommentor: '',
                norm: '',
                advice: '',
                formula: '',
                type: 'Default',
                dgl_ref: dgl_ref,
                report_ref: report_ref
            };
            localStorage.setItem("annotationJustCreated", "true")
            let state = props.annotationData
            state.annotations.push(annotation)
            props.setAnnotationData(state)
            localStorage.setItem('isSave', 'No');
            // set the lv document
            let lvDocument = getCurrentStateOfLvDocument();
            removeLVDocumentDB();
            setLVDocumentDB(JSON.stringify(lvDocument));
        }
    }

    let highlightSelection = async (el, oz, state, annotationAttributs) => {
        /**
         * Triggers the highlight.
         *
         * @type {VoidFunction}
         */
        // Hinweis has no value, so Calculation UI in Annotator UI needs to be read only
        // and default value set to zero.
        if (state === 'Hinweis') {
            console.log('Present annotation is in hinweis state.');
            $('#kalkulationValue').val('Hinweis hat kein Wert!').attr('readonly', true);
            $('#kalkulationTotalValue').val('0');
        } else {
            $('#kalkulationValue').attr('readonly', false);
        }
        let elem = el.target;
        getSelectionWithEndOffsets(elem, state, oz, annotationAttributs);
    };

    //endregion

    return (
        <>
            {highlightPossibilty ? (
                <p
                    id={ozDataUnitValue.row_id}
                    onMouseUp={(event) => {
                        let menge;
                        if (ozDataUnitValue.menge == null) {
                            menge = 1;
                        } else {
                            menge = ozDataUnitValue.menge;
                        }

                        highlightSelection(event, ozDataUnitValue.ref, stateValue.tag, [
                            ozDataUnitValue.row_id,
                            menge,
                            ozDataUnitValue.hinweis,
                            ozDataUnitValue.dgl_ref,
                            ozDataUnitValue.report_ref
                        ]).then((r) => r);
                    }}
                    onContextMenu={async (event) => {
                        event.preventDefault();
                        if (event.target.id.length >= 32) {
                            /* UUID - rfc 4122 */
                        }
                        let state = await props.annotationData
                        removingAnnotation(event.target.id, state,props.parsedlv_id).then((r) => r);
                        let newData = state.annotations.filter((obj) => obj.unique_id !== event.target.id);
                        let newState = state
                        newState.annotations = newData

                        props.setAnnotationData(newState);
                    }}
                    dangerouslySetInnerHTML={{__html: ozDataUnitValue.long_text}}>


                </p>
            ) : (
                <p id={ozDataUnitValue.row_id}>
                    {isNothing(ozDataUnitValue.long_text) ? 'Nan' : ''}
                    {ozDataUnitValue.long_text}
                </p>
            )}
        </>
    );
}

export default HighlightComponent;
